import { Link } from 'react-router-dom';
import { AppShell } from '../components/Layout';

export function NotFound() {
  return (
    <AppShell nav={[{ to: '/', label: 'Home' }]}>
      <div className="shell shell--narrow section">
        <div className="card stack center">
          <h1 style={{ fontSize: '1.4rem', margin: 0 }}>Page not found</h1>
          <p className="muted small" style={{ margin: 0 }}>
            The page you are looking for does not exist, or the link has expired.
          </p>
          <Link className="btn btn--primary" to="/">Go to the home page</Link>
        </div>
      </div>
    </AppShell>
  );
}
